const CUSTOM_TAGS = {
  CARD: "!card",
  CONTAINER: "!container",
  DATA: "!data",
  DATA_SOURCE: "!data_source",
  HEADER: "!header",
  QUERY: "!query",
  LTR: "!ltr",
  TR: "!tr",
  VARIABLE: "!variable",
  GOAL: "!goal",
  MD: "!md",
  CMS: "!cms"
};
export {
  CUSTOM_TAGS
};
